import { render } from "./InteractionsPage.vue?vue&type=template&id=319d491e&ts=true"
import script from "./InteractionsPage.vue?vue&type=script&lang=ts"
export * from "./InteractionsPage.vue?vue&type=script&lang=ts"

import "./InteractionsPage.vue?vue&type=style&index=0&id=319d491e&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__